import React, { useContext } from 'react';
import { Sun, Moon } from 'lucide-react';
import { ThemeContext } from '../../contexts/ThemeContext';

// The theme picker — same store as the user-menu quick toggle, so the two
// controls can never disagree.
export default function Appearance() {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl font-bold mb-2">Appearance</h2>
        <p className="text-muted">Choose your preferred color theme.</p>
      </div>

      <div className="flex gap-3">
        <button
          onClick={() => theme === 'dark' && toggleTheme()}
          className={`btn-secondary flex items-center gap-2 ${theme === 'light' ? 'active' : ''}`}
          aria-pressed={theme === 'light'}
        >
          <Sun size={18} />
          Light
        </button>
        <button
          onClick={() => theme === 'light' && toggleTheme()}
          className={`btn-secondary flex items-center gap-2 ${theme === 'dark' ? 'active' : ''}`}
          aria-pressed={theme === 'dark'}
        >
          <Moon size={18} />
          Dark
        </button>
      </div>
    </div>
  );
}
